export enum SlackChannelWorkspace {
  TWU = 'TWU',
  RedCore = 'RedCore',
}

export const SLACK_CHANNEL_WORKSPACE_COLORS: Record<SlackChannelWorkspace, string> = {
  [SlackChannelWorkspace.TWU]: '--color-twu-project',
  [SlackChannelWorkspace.RedCore]: '--color-readcore-project',
};
